export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5200.89dddb5e.jpg";